var directionsService,map,markerArray,stepDisplay,latlng,start,end;
markerArray = [];

if(typeof window.getLatLong != 'function') {
  function getLatLong(addresses, callback){
    var address = addresses[0].replace(".","+");
    var approx_addr = addresses[1].replace(".","+");
    var geo = new google.maps.Geocoder;
    geo.geocode({'address':address},function(results, status){
      if (status == google.maps.GeocoderStatus.OK && results.length > 0){
        callback(results[0].geometry.location);
      }
      else{
        if(approx_addr && approx_addr.length > 0){
          geo.geocode({'address':approx_addr},function(results, status){
            if (status == google.maps.GeocoderStatus.OK && results.length > 0){
              callback(results[0].geometry.location);
            }
          });
        }
      }
    });
  }
}

if(typeof window.initialize != 'function') {
  function initialize(geometry_location) {
    if(typeof(geometry_location) == "undefined") return;

    latlng = new google.maps.LatLng(geometry_location.lat(),geometry_location.lng());

    directionsDisplay = new google.maps.DirectionsRenderer({draggable: true});
    var myOptions = {zoom: 16,
      center: latlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false
    };
    map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
    var marker = new google.maps.Marker({
      position: latlng,
      title: jQuery('#map_wrapper').data().title,
      map: map
    });
    directionsDisplay.setMap(map);
    stepDisplay = new google.maps.InfoWindow();
    directionsDisplay.setPanel(document.getElementById("route-info"));
  }
}

if(typeof window.keypress != 'function') {
  function keypress(e){
    var Ucode=e.keyCode? e.keyCode : e.charCode
    if (Ucode == 13) calcRoute();
  }
}

if(typeof window.calcRoute != 'function'){
  function calcRoute(){
    var start_route = jQuery("#start_route");
    start_route.trigger('calcRoute');
    start = start_route.val();
    end = latlng;
    var request = {
      origin: start,
      destination: end,
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    directionsService.route(request, function(response, status) {
      if(status == google.maps.DirectionsStatus.OK){
        directionsDisplay.setDirections(response);
        if(typeof TACallbackClickDirection == 'function'){
          setTimeout(function(){
            jQuery('.adp-placemark, .adp-directions', document).each(function(){
              el = jQuery(this)[0];
              el.addEventListener('click', TACallbackClickDirection, false);
            });
          }, 1000);
        }
      }
    });
    jQuery('#box-route-info').show();
    jQuery('#route-info').show();
  }
}

if(typeof window.showSteps != 'function') {
  function showSteps(directionResult) {
    var myRoute = directionResult.routes[0].legs[0];

    for (var i = 0; i < myRoute.steps.length; i++) {
      var marker = new google.maps.Marker({
        position: myRoute.steps[i].start_point,
        map: map
      });
      attachInstructionText(marker, myRoute.steps[i].instructions);
      markerArray[i] = marker;
    }
  }
}

if(typeof window.attachInstructionText != 'function') {
  function attachInstructionText(marker, text) {
    google.maps.event.addListener(marker, 'click', function() {
      stepDisplay.setContent(text);
      stepDisplay.open(map, marker);
    });
  }
}

if(typeof window.makeAjaxCall != 'function') {
  function makeAjaxCall(url,container,pop){
    if(window.location.pathname != url){
      toggleOverlay();
      jQuery.ajax({
        url: url,
        timeout: 60000,
        complete: function(xhr){
          toggleOverlay();
          var data = xhr.responseText;
          var title = Base64.decode(xhr.getResponseHeader("X-Page-Title")).replace("'","\\'");
          if(!pop){
            //history.pushState({container: container,url: url}, title, url);
            //window.history.pushState({container: container,url: url}, title, url);
            window.history.pushState({url: "" + url + ""}, title, url);
            if (typeof(window.history.pushState) == 'function'){}
          }
          document.title = title;
          jQuery(container).html(data);
          refreshAddThis();
        }
      });
    }
  }
}

function ajaxHTML5(url,container,pop){
  if(window.location.pathname != url){
    toggleOverlay();
    jQuery.ajax({
      url: url,
      timeout: 60000,
      complete: function(xhr){
        toggleOverlay();
        var data = xhr.responseText;
        var title = Base64.decode(xhr.getResponseHeader("X-Page-Title"));
        if(!pop)
          History.pushState(null, title, url);

        document.title = title;
        jQuery(container).html(data);
        jQuery('body').trigger('ajaxHTML5:complete');
        refreshAddThis();
      }
    });
  }
}

if(typeof window.addEvent != 'function') {
  function addEvent(evnt, elem, func) {
    if (elem.addEventListener)  // W3C DOM
      elem.addEventListener(evnt,func,false);
    else if (elem.attachEvent) { // IE DOM
      elem.attachEvent("on"+evnt, func);
    }
    else { // No much to do
      elem[evnt] = func;
    }
  }
}

if(typeof window.arrowsTrigger != 'function') {
  function arrowsTrigger(page,target,arrow){
    addEvent("keydown",document,function(event){
      if(jQuery(page).length>0){
        var key=event.which;
        if(key==37 && arrow=="left"){
          event.preventDefault();
          jQuery(target).trigger("click");
        }
        else if(key==39 && arrow=="right"){
          event.preventDefault();
          jQuery(target).trigger("click");
        }
        else if(key==38 && arrow=="up"){
          event.preventDefault();
          jQuery(target).trigger("click");
        }
        else if(key==40 && arrow=="down"){
          event.preventDefault();
          jQuery(target).trigger("click");
        }
      }
    });
  }
}

if(typeof window.callbackCarouselEventsAll != 'function') {
  function callbackCarouselEventsAll(carousel){
    jQuery('a[data-date]').bind('click', function(event,prevent){
      if(!typeof(prevent) === "undefined") event.preventDefault();
      var temp_startjCarousel = parseInt(jQuery(this).parents('li').attr('jcarouselindex'),10);
      carousel.scroll(jQuery.jcarousel.intval(temp_startjCarousel));
    });
    if(typeof(window.extendCB_CarouselEventsAll)=="function") extendCB_CarouselEventsAll(carousel);
  }
}

if(typeof window.toggleOverlay != 'function') {
  function toggleOverlay(){
    var global_overlay = jQuery('#global-overlay');
    if(global_overlay.length > 0) global_overlay.remove();
    else jQuery('body').append('<div id="global-overlay" class="o60"></div>');
  }
}
/*
if(typeof window.loading != 'function') {
  function loading(addClass){
    var data_loading = jQuery('div[data-loading]');
    var src = data_loading.length>0 ? data_loading.attr('data-loading') : document.location.protocol+"//"+window.location.host+"/wp-content/themes/StartTheme3.0/images/bar-loader.gif";
    return '<div id="loading" class="center '+addClass+'"><img src="'+src+'" alt="loading" /></div>';
  }
}
*/
if(typeof window.loading != 'function') {
  function loading(){
    var data_loading = jQuery('div[data-loading]');
    var src = data_loading.length>0 ? data_loading.attr('data-loading') : document.location.protocol+"//"+window.location.host+"/wp-content/themes/StartTheme3.0/images/bar-loader.gif";
    return '<div id="loading" class="center"><img src="'+src+'" alt="loading" /></div>';
  }
}

if(typeof window.jCarouselAutoInit != 'function') {
  function jCarouselAutoInit(selector,jCarouselParams){
    jQuery(selector).each(function(){
      var thisSelector = jQuery(this);
      var start = parseInt(thisSelector.attr('data-jcarousel-start'),10);
      if(start < 1 || !start) start = 0;
      jCarouselParams = jQuery.extend({start: start},jCarouselParams);
      if(thisSelector.children().length>0)
        thisSelector.jcarousel(jCarouselParams);
    });
  }
}

if(typeof window.toggle_default_text != 'function') {
  function toggle_default_text(field_selector){
    var search_input = jQuery(field_selector);
    if(search_input.length > 0){
      jQuery(search_input).on('focus',function(event){
        if(search_input.val() == search_input.data().default_value)
          search_input.val('');
      });

      jQuery(search_input).on('blur',function(event){
        if(search_input.val() == '')
          search_input.val(search_input.data().default_value);
      });
    }
  }
}

if(typeof window.removeDefaultValueOnSubmit != 'function') {
  function removeDefaultValueOnSubmit(form_selector){
    jQuery(form_selector).find('input[type=text]').each(function(i, c) {
      if(jQuery(c).val() == jQuery(c).data().default_value)
        jQuery(c).val('');
    })
  }
}

if(typeof window.AutoRemoveDefaultValueOnSubmit != 'function') {
  function AutoRemoveDefaultValueOnSubmit(form_selector){
    jQuery(form_selector).on('submit',function(){
      removeDefaultValueOnSubmit(form_selector);
    })
  }
}

if(typeof window.carouselEventsAll != 'function') {
  function carouselEventsAll(startjCarousel,arrayText){
    if(typeof arrayText.vertical === 'undefined')
      arrayText.vertical = false;

    if(typeof arrayText.scroll === 'undefined')
      arrayText.scroll = 3;

    today = arrayText.todayText;
    selector = typeof(arrayText.selector) == 'undefined' ? '#carousel-events' : arrayText.selector;

    jQuery(selector).jcarousel({
      vertical: arrayText.vertical,
      animation: 500,
      scroll: arrayText.scroll,
      start: parseInt(startjCarousel,10),
      initCallback: callbackCarouselEventsAll,
      buttonPrevHTML: '<span class="fg2">'+ (typeof arrayText.prevText !== 'undefined' ? '&laquo; '+arrayText.prevText : '') +'</span>',
      buttonNextHTML: '<span class="fg2">'+ (typeof arrayText.nextText !== 'undefined' ? arrayText.nextText+' &raquo;' : '') + '</span>'
    });
  }
}

if(typeof window.reverseZindex != 'function') {
  function reverseZindex(selector){
    var num = jQuery(selector).length;
    if(num > 0){
      jQuery(selector).each(function(i, c) {
        jQuery(c).css('z-index', num - i);
      });
    }
  }
}

if(typeof window.video_media_js != 'function') {
  function video_media_js(selector_carousel_item){
    jQuery(selector_carousel_item).on("click",function(event){
      event.preventDefault();
      var link = jQuery(this);
      var video_media_player = jQuery("#"+link.data('video-container'));
      var frame = link.data().videoIframe;
      video_media_player.html(frame);

      if(jQuery('[data-video-attr=author]').length > 0){
        author = jQuery('[data-video-attr=author]')
        if(author[0].tagName == "A"){
          author.text(link.data('author'));
          author.attr('title', link.data('author'));
          author.attr('href', link.data('authorLink'));
        } else {
          author.html(link.data('author'));
        }
      }
      if(jQuery('[data-video-attr=date]').length > 0) jQuery('[data-video-attr=date]').html(link.data('date'));
      if(jQuery('[data-video-attr=album]').length > 0) jQuery('[data-video-attr=album]').html(link.data('album'));
      if(jQuery('[data-video-attr=title]').length > 0) jQuery('[data-video-attr=title]').html(link.attr('title'));
      var img_avatar = jQuery('img[data-video-attr=avatar]');
      if(img_avatar.length > 0){
        img_avatar.attr('src', link.data('avatar'));
        img_avatar.attr('alt', link.data('author'));
      }

      if(link.data('box-share')){
        img = link.find("img").length > 0 ? link.find("img").attr("src") : link.data("image");
        reinitializeAddThisWithCopyLink(link.data('box-share'), link.attr("href"), link.attr("title"), img);
      }
      refreshAddThis();
      // Le funzioni di callback devono essere "window.nome_funzione = function(){...}"
      var callbacks = link.data('callbacks');
      if(callbacks){
        jQuery.each(callbacks.split(","), function(index, fn){
          window[fn.trim()](link);
        })
      }
    });
  }
}

if(typeof window.clickableBox != 'function') {
  /*
   Indicando come selettore un elemento di tipo list (tag li) o di un suo figlio, automaticamente rende cliccabile tutto
   l'elemento list, utilizzando il link del primo elemento di tipo anchor (tag a)
   */
  function clickableBox(selector){
    jQuery(selector).on("click",function(e){
      var box = jQuery(this);
      if(!jQuery(this).is('li'))
        box = box.parents("li");
      var $link = box.find('a');
      if($link[0])
        $link[0].click();
    });
  }
}

if(typeof window.slideshow != 'function') {
  /*
   Richiamando la funzione si inizializza lo slideshow che deve avere le seguenti caratteristiche:
   - essere contenuto in un elemento con id = "slideshow"
   - le immagini dimensione slideshow devono essere contenute in un elemento con id = "featured-slideshow"
   - via php va inserita solo la prima immagine all'interno di #featured-slideshow nella seguente forma:

   <div id="featured-slideshow">
   <div class="featured-slideshow-inner" data-iterator="0" style="height: <?php echo $height; ?>px;width: <?php echo $width; ?>px;">
   <a href="<?php echo $images[0]['album_link']; ?>" title="<?php echo $images[0]['media']['caption']; ?>">
   <img src="<?php echo $images[0]['photo_slideshow']; ?>" alt="<?php echo $images[0]['media']['caption']; ?>" width="<?php echo $width; ?>" height="<?php echo $height; ?>" data-href="<?php echo $images[0]['album_link']; ?>" />
   </a>
   </div>
   </div>

   - avere una lista di tutte le immagini contenute nello slideshow, ad esempio sotto forma di thumbnails
   - nel caso di una lista di thumbnails, deve avere la seguente struttura:
   <div id="box-thumb-slideshow">
   <?php foreach($images as $i=>$image): ?>
   <div class="slide-<?php echo $i; ?> <?php if($i == 0) echo "active"; ?>">
   <img src="<?php echo $image['photo_carousel']; ?>" data-iterator="<?php echo $i; ?>" data-slideshow="<?php echo $image['photo_slideshow']; ?>" alt="<?php echo $image['media']['caption']; ?>" data-width="<?php echo $width ?>" data-height="<?php echo $height ?>" data-href="<?php echo $image['album_link']; ?>" data-date="<?php echo $image['date']; ?>" />
   </div>
   <?php endforeach; ?>
   </div>

   - nel caso di una lista di anchor, deve avere la seguente struttura:
   <div id="nav-slideshow">
   <?php foreach($images as $i=>$image){ ?>
   <a href="#" class="slide-<?php echo $i; ?> <?php if($i == 0) echo "activeSlide"; ?>" data-iterator="<?php echo $i; ?>" data-slideshow="<?php echo $image['photo_slideshow']; ?>" title="<?php echo $image['media']['caption']; ?>" data-width="<?php echo $width ?>" data-height="<?php echo $height ?>" data-href="<?php echo $image['album_link']; ?>" data-date="<?php echo $image['date']; ?>"></a>
   <?php } ?>
   </div>

   - è possibile creare una funzione callbackSlideshow che definisce il comportamento dello slideshow nel momento in cui
   termina il cambiamento di un'immagine altrimenti viene richiamato un comportamento standard che prevede l'uso di
   thumbnails.

   - se si vogliono aggiungere i pulsanti di navigazione prev-next, basta inserire questo codice e settare il css
   <div id="controls">
   <div class="prev"><?php _e('Prev', 'translator') ?></div>
   <div class="next"><?php _e('Next', 'translator') ?></div>
   </div>
   */
  function slideshow(){
    var slideshow = jQuery('#slideshow');
    if(slideshow.length > 0 && slideshow.children("iframe").length===0){

      jQuery(window).load(function(){

        var boxSlideshow = jQuery("#featured-slideshow");
        var boxInfoSlideshow = jQuery("#info-photo-slideshow");

        var thumbs_container = jQuery('#box-thumb-slideshow');
        var nav_container = jQuery('#nav-slideshow');
        var thumbs,thumbs_img,thumbs_nav;

        if(thumbs_container.length > 0)
          thumbs_img = thumbs_container.find('img');

        if(nav_container.length > 0)
          thumbs_nav = nav_container.find('a');

        if(thumbs_container.length > 0 && thumbs_img.length > 0)
          thumbs = thumbs_img;
        else if(nav_container.length > 0 && thumbs_nav.length > 0)
          thumbs = thumbs_nav;
        else
          thumbs = []

        if(thumbs.length > 0){
          thumbs.each(function(i){
            var album_link = jQuery(this).data().href;
            var src = jQuery(this).data().slideshow;
            var width = jQuery(this).data().width;
            var height = jQuery(this).data().height;
            var date = jQuery(this).data().date;
            var alt = jQuery(this).is('img') ? jQuery(this).attr('alt') : jQuery(this).attr('title');

            if(i > 0)
              boxSlideshow.append('<div class="featured-slideshow-inner" data-iterator="'+i+'" style="height: '+height+'px"><a href="'+album_link+'" title="'+alt+'"><img src="'+src+'" alt="'+alt+'" width="'+width+'" height="'+height+'" data-href="'+album_link+'"  data-date="'+date+'" /></a></div>');
          });


          if(thumbs_container.length > 0)
            thumbs_img.on("click",function(){
              boxSlideshow.cycle(jQuery(this).data().iterator);
            });

          if(nav_container.length > 0)
            thumbs_nav.on("click",function(){
              boxSlideshow.cycle(jQuery(this).data().iterator);
            });

        }

        boxSlideshow.cycle({
          fx:     'fade',
          speed:   250,
          timeout: 6000,
          pause: 1,
          next: '#controls .next',
          prev: '#controls .prev',
          slideExpr: '.featured-slideshow-inner',
          height: jQuery(this).height,
          after: function() {
            if(typeof window.callbackSlideshow == 'function') {
              callbackSlideshow();
            }else{
              var boxThumb = boxInfoSlideshow.find(".box-thumb");
              boxThumb.show();
              boxSlideshow.children().each(function(){
                if(jQuery(this).css('opacity')==1) {

                  jQuery("#box-thumb-slideshow div").removeClass("active");

                  var nSlide = jQuery(this).data().iterator;
                  jQuery('.slide-'+nSlide).addClass("active");

                  var link = jQuery(this).find('[data-href]').data().href;
                  boxInfoSlideshow.find(".readall").attr("href",link);
                }
              });
            }
          }
        });

        boxSlideshow.hover(function(){boxInfoSlideshow.show();}, function(){boxInfoSlideshow.hide();});
        boxInfoSlideshow.hover(function(){boxInfoSlideshow.show();}, function(){boxInfoSlideshow.hide();});
      })
    }
  }
}

if(typeof window.open_box != 'function') {
  function open_box(){
    jQuery("div[aria-labelledby='ui-dialog-title-message-box']").addClass('openbox_shop_bg');
    jQuery("div[aria-labelledby='ui-dialog-title-message-box'] .ui-dialog-titlebar").hide();
    jQuery('#message-box').dialog('open');
  }
}

if(typeof window.sendMail != 'function') {
  function sendMail(){
    var ok=true;
    var email = document.getElementsByName('sender');
    email=email[0];
    var name = document.getElementsByName('name');
    name=name[0];
    var surname = document.getElementsByName('surname');
    surname=surname[0];
    var quantity = document.getElementsByName('quantity');
    quantity=quantity[0];
    var text = document.getElementsByName('text');
    text=text[0];
    var filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
    if (!filter.test(email.value)){
      alert(data_json.alert_valid_mail);
      email.focus();
      ok=false;
    }
    if(ok && name.value==""){
      alert(data_json.alert_valid_name);
      name.focus();
      ok=false;
    }
    if(ok && surname.value==""){
      alert(data_json.alert_valid_surname);
      surname.focus();
      ok=false;
    }
    var filter_q= /\d/;
    if(!filter_q.test(quantity.value)){
      alert(data_json.alert_valid_quantity);
      quantity.focus();
      ok=false;
    }
    var message="Oggetto richiesto: "+data_json.itemshop+"<br> Quantità: "+quantity.value+"<br> Note:<br>"+text.value;
    if(ok){
      data='name='+name.value+'&surname='+surname.value+'&sender='+email.value+'&text='+message+'&recipient='+data_json.recipient+'&society='+data_json.society;
      jQuery.ajax({
        type: 'POST',
        url: data_json.plugin_url,
        data: data,
        success: function(msg){
          if(msg=="OK"){
            alert("Message sent!");
            jQuery('#message-box').dialog('close');
          }
          else
            alert("Error!");
        }
      });
    }
  }
}

/*
function jSendMail(form_obj){
  var ok=true;
  var email = form_obj.find('[name=sender]');
  var name = form_obj.find('[name=name]');
  var surname = form_obj.find('[name=surname]');
  var quantity = form_obj.find('[name=quantity]');
  var text = form_obj.find('[name=text]');
  var data_submit = form_obj.find('[type=submit]').data();

  var filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
  if (!filter.test(email.val())){
    alert(data_submit.alert_valid_mail);
    email.focus();
    return false;
  }
  if(ok && name.val()==""){
    alert(data_submit.alert_valid_name);
    name.focus();
    return false;
  }
  if(ok && surname.val()==""){
    alert(data_submit.alert_valid_surname);
    surname.focus();
    return false;
  }
  var filter_q= /\d/;
  if(!filter_q.test(quantity.val())){
    alert(data_submit.alert_valid_quantity);
    quantity.focus();
    return false;
  }
  var message=data_submit.oggetto_richiesto_text+data_submit.itemshop+"<br/>"+data_submit.quantita_text+quantity.val()+"<br/>"+data_submit.note_text+"<br>"+text.val();


  data='name='+name.val()+'&surname='+surname.val()+'&sender='+email.val()+'&text='+message+'&recipient='+data_submit.recipient+'&society='+data_submit.society;
  jQuery.ajax({
    type: 'POST',
    url: data_submit.plugin_url,
    data: data,
    success: function(msg){
      if(msg=="OK"){
        alert(data_submit.message_sent_text);
        jQuery('#message-box').dialog('close');
      }
      else
        alert(data_submit.message_error_text);
    }
  });
}
*/

if(typeof window.changeContentVideo != 'function') {
  function changeContentVideo(params) {
    var boxVideo = jQuery('#boxVideo');
    var height = boxVideo.height();
    var width = boxVideo.width();
    boxVideo.html("<div id='player"+params['id']+"' style='width:"+width+"px;height:"+height+"px;margin:0 20px 20px 0;float:left'>"+params['video_iframe']+"</div>");
    jQuery('#title').text(decodeURIComponent(params['caption'].replace(/\+/g, '%20')));
    jQuery('#author').html(params['name']);
    if (typeof params['author_link'] !== 'undefined')
      jQuery('#author').attr('href',params['author_link']);
    jQuery('#album').html(decodeURIComponent(params['album'].replace(/\+/g, '%20')));
    jQuery('#category').html(params['category']);
    if (typeof params['category_link'] !== 'undefined')
      jQuery('#category').attr('href',params['category_link']);
    jQuery('#data').html(params['data']);
    if(jQuery('p').css('display') == 'none') {jQuery('p').css('display','block');}
  }
}


function data_resize_and_center(){
  jQuery('[data-rac=true]').one('load', function(){

    var img = jQuery(this);
    var parent = img.parent();
    while(parent.css('display') == 'inline'){
      parent = parent.parent();
    }

    var $height = parent.height();
    var $width = parent.width();
    var $w_img = img[0].width; //img.width()
    var $h_img = img[0].height; //img.height()

    if($w_img != 0 || $h_img != 0){
      var $rbox = $height > 0 ? $width/$height : $width;
      var $rimg = $w_img / $h_img;

      if($rimg > $rbox){
        var $mleft = Math.floor((($height * $rimg) - $width) / (-2));
        img.css({'height':$height +'px','margin-left':$mleft +'px'});
      }else{
        $rimg = $h_img / $w_img;
        var $mtop =  Math.floor((($width * $rimg) - $height) / (-2));
        img.css({'width':$width +'px','margin-top':$mtop +'px'});
      }
    }

    img.css({'visibility':'visible'});
    img.attr('data-rac','false');

  }).each(function(){
    if(this.complete) jQuery(this).load();
  });
}

function data_center_image(){
  jQuery('[data-cImg=true]').one('load', function() {

    var img = jQuery(this);
    var parent = img.parent();
    while(parent.css('display') == 'inline'){
      parent = parent.parent();
    }

    var $height = parent.height();
    var $width = parent.width();
    var $w_img = img[0].width; //img.width()
    var $h_img = img[0].height; //img.height()
    var $stretch = img.data('stretch');
    var $mleft;
    if($w_img != 0 || $h_img != 0){
      if($w_img < $width && $h_img < $height && !$stretch){
        $mleft = Math.floor(($width - $w_img) / 2);
        var $mtop = Math.floor(($height - $h_img) / 2);
        img.css({'margin-left':$mleft +'px','margin-top':$mtop +'px'});
      }
      else {
        var $rbox = $height > 0 ? $width / $height : $width;
        var $rimg = $w_img / $h_img;

        if($rimg < $rbox){
          $mleft = Math.floor((($height*$rimg)-$width)/ (-2));
          img.css({'height':$height +'px','margin-left':$mleft +'px'});
        }
        else {
          $rimg = $h_img / $w_img;
          $mtop = Math.floor((($width * $rimg) - $height) / (-2));
          img.css({'width':$width +'px','margin-top':$mtop +'px'});
        }
      }
    }

    img.css({'visibility':'visible'});
    img.attr('data-cImg','false');
  }).each(function() {
      if(this.complete) jQuery(this).load();
  });
}